import React from "react";
import { Link } from "react-router-dom";

// Globaler Footer. Wird in App.js auf allen Seiten gerendert (auch im
// eingeloggten Zustand). Das Impressum ist hier verlinkt und daher aus dem
// Hauptmenue entfernt.
const Footer = () => {
  return (
    <footer className="myn-footer">
      <div className="myn-container">
        <div className="myn-grid" style={{ alignItems: "start" }}>
          <div>
            <img src="/myn-logo-full.svg" alt="MYN.CLUB" style={{ height: "32px", filter: "brightness(0) invert(1)" }} />
            <p style={{ marginTop: "1rem", maxWidth: "34ch", color: "#9fb0c4" }}>
              Die Plattform für digitale Produkte und mehrstufigen Vertrieb –
              erstellen, verwalten, skalieren.
            </p>
          </div>
          <div>
            <h3 className="myn-h3" style={{ color: "#fff" }}>Produkte</h3>
            <p><a href="/#produkte">Übersicht</a></p>
            <p><Link to="/register">MYN Reviews</Link></p>
            <p><a href="https://www.wirrt.com" target="_blank" rel="noreferrer">WIRRT</a></p>
          </div>
          <div>
            <h3 className="myn-h3" style={{ color: "#fff" }}>Plattform</h3>
            <p><a href="/#so-funktionierts">So funktioniert&apos;s</a></p>
            <p><Link to="/register">Kostenlos starten</Link></p>
            <p><Link to="/login">Anmelden</Link></p>
          </div>
          <div>
            <h3 className="myn-h3" style={{ color: "#fff" }}>Rechtliches</h3>
            <p><Link to="/impressum">Impressum</Link></p>
            <p><Link to="/agb">AGB</Link></p>
            <p><Link to="/datenschutz">Datenschutz</Link></p>
          </div>
        </div>
        <hr style={{ borderColor: "rgba(255,255,255,0.12)", margin: "1.5rem 0" }} />
        <p style={{ margin: 0, color: "#9fb0c4", fontSize: "0.9rem" }}>
          © {new Date().getFullYear()} MYN.CLUB · EDEL Investment GmbH. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
